// extracted by mini-css-extract-plugin
export default {"tip":"styles_tip__He8I5","model":"styles_model__Ky9JJ","example":"styles_example__4aM9f","img":"styles_img__czhEa"};